import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";
  import { computed } from "vue";
  import { BuilderMessageType } from "@/enums/BuilderMessageType";
  import {
    buildPriceMessagePartOne,
    buildPriceMessagePartTwo,
    changeRequestMessageParts,
  } from "@/constants/builderMessage";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderOpenMessageReviewQuote',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: BuilderMessageType.BUILD_PRICE,
    },
    lot: {
      type: Number,
      required: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(680);

  const props = __props;

  const desktopMessageParts = computed(() => {
    return props.type === BuilderMessageType.BUILD_PRICE
      ? buildPriceMessagePartOne.map((part) =>
          part.replace("{lot}", String(props.lot))
        )
      : changeRequestMessageParts;
  });

  const buttonText = computed(() => {
    return props.type === BuilderMessageType.BUILD_PRICE
      ? "Complete"
      : "Request a change to my design";
  });

  const openStart = () => {
    //There is currently no logic
  };
  const openRequestChange = () => {
    //There is currently no logic
  };

  const handleButtonClick = () => {
    return props.type === BuilderMessageType.BUILD_PRICE
      ? openStart()
      : openRequestChange();
  };

const __returned__ = { isDesktop, props, desktopMessageParts, buttonText, openStart, openRequestChange, handleButtonClick, get useIsDesktop() { return useIsDesktop }, computed, get BuilderMessageType() { return BuilderMessageType }, get buildPriceMessagePartOne() { return buildPriceMessagePartOne }, get buildPriceMessagePartTwo() { return buildPriceMessagePartTwo }, get changeRequestMessageParts() { return changeRequestMessageParts } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})